var map = {
	"./Captura de pantalla 2024-06-21 165746.png": 6776,
	"./IconosDeportes/atletismo.png": 1246,
	"./IconosDeportes/balon-basquet.png": 8566,
	"./IconosDeportes/balon-basquetclasico.png": 3476,
	"./IconosDeportes/balon-futbol.png": 9445,
	"./IconosDeportes/balon-tocho.png": 9460,
	"./IconosDeportes/balon-voleibol.png": 7005,
	"./LogoEmporioSport.svg": 9198,
	"./Recurso_1.png": 1907,
	"./bg/bg-img-1.png": 8783,
	"./calidades/basic.png": 2169,
	"./calidades/basic.svg": 7041,
	"./calidades/clasico.png": 9963,
	"./calidades/clasico.svg": 1475,
	"./calidades/hd.png": 2943,
	"./calidades/hd.svg": 9773,
	"./calidades/hdpremium.png": 7796,
	"./calidades/super.png": 8858,
	"./calidades/super.svg": 106,
	"./calidades/vento.png": 435,
	"./calidades/vento.svg": 3987,
	"./canchas/Cancha-atletismo.png": 1635,
	"./canchas/Cancha-atletismo2.png": 5289,
	"./canchas/Cancha-basquetbol.png": 3731,
	"./canchas/Cancha-futbol.png": 8769,
	"./canchas/Cancha-tocho.png": 8264,
	"./canchas/Cancha-voleibol.png": 369,
	"./deportes/Hombre_atletismo.png": 9691,
	"./deportes/Hombre_basquetbol.png": 7131,
	"./deportes/Hombre_futbol.png": 3385,
	"./deportes/Hombre_tocho.png": 8656,
	"./deportes/Hombre_voleibol.png": 6537,
	"./deportes/Mujer_atletismo.png": 3235,
	"./deportes/Mujer_atletismo2.png": 7785,
	"./deportes/Mujer_futbol.png": 7313,
	"./deportes/Mujer_tocho.png": 312,
	"./deportes/Mujer_voleibol.png": 6897,
	"./deportes/basquetbol_2.0.png": 7786,
	"./deportes/basquetbol_hombre 2.0.png": 3585,
	"./deportes/mujer_basquetbol.png": 2051,
	"./deportes/tailler.png": 2486,
	"./elementos/Personas-emprende.png": 6533,
	"./elementos/accesorios.png": 278,
	"./elementos/img-uniformes-deportivos-jugadores.png": 7596,
	"./ellesport.png": 5374,
	"./ilsport.png": 1637,
	"./incluye/Short.svg": 778,
	"./incluye/playera.svg": 8,
	"./loading-animation.gif": 2724,
	"./sarorial2.png": 1191,
	"./sarorial2.png.png": 4936,
	"./sartorial.png": 1123,
	"./tailler.png": 8953,
	"./uniforme/Uniforme-atletismo-.png": 7921,
	"./uniforme/Uniforme-atletismo-reverso.png": 8121,
	"./uniforme/Uniforme-atletismo.png": 4742,
	"./uniforme/Uniforme-basquetbol-.png": 9767,
	"./uniforme/Uniforme-basquetbol-reverso.png": 7887,
	"./uniforme/Uniforme-basquetbol.png": 9040,
	"./uniforme/Uniforme-futbol-.png": 4377,
	"./uniforme/Uniforme-futbol-reverso.png": 4257,
	"./uniforme/Uniforme-futbol.png": 9662,
	"./uniforme/Uniforme-tocho-.png": 3192,
	"./uniforme/Uniforme-tocho-reverso.png": 4018,
	"./uniforme/Uniforme-tocho.png": 9849,
	"./uniforme/Uniforme-voleibol-.png": 9649,
	"./uniforme/Uniforme-voleibol-reverso.png": 3801,
	"./uniforme/Uniforme-voleibol.png": 9254,
	"./uniforme/sartorial.png": 5025,
	"./unnamed.gif": 6325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;